<template>
  <div
    @click="buttonClicked()"
    :class="`m-1 ${clicked_state && clicked ? 'clicked-btn' : ''} ${
      display_type == 'D' ? 'button-3d' : 'simple-2d'
    }`"
    :style="buttonAStyles"
  >
    <span v-if="!containsFractions(text)" class="show-white-space">{{ text }}</span>
    <div v-else class="show-white-space">
      <show-fractions :text="text" />
    </div>
    <!--If clipart layers added-->
    <show-clipart-layer
      v-if="layers.length"
      :layers="layers"
    ></show-clipart-layer>
    <!--If Tables added-->
    <show-tables v-if="tables.length" :tables="tables"></show-tables>
    <!--If Clock added-->
    <show-clock v-if="clock" :clock="clock"></show-clock>
    <!--If PROTRACTOR added-->
    <show-protractor
      v-if="protractor"
      :protractor="protractor"
    ></show-protractor>
    <!--If Custom Layout added-->
    <show-custom-layout
      v-if="custom_layout"
      :is_outer_height_extra="false"
      :outer_width="`${custom_layout.parent_width}px`"
      :custom_layout="custom_layout"
    ></show-custom-layout>
    <!--If Bar Chart added-->
    <show-bar-chart v-if="bar_chart" :bar_chart="bar_chart"></show-bar-chart>
    <!--If Line Chart added-->
    <show-line-chart
      v-if="line_chart"
      :line_chart="line_chart"
    ></show-line-chart>
    <!--If Thermometer added-->
    <show-thermometer
      v-if="thermometer"
      :thermometer="thermometer"
    ></show-thermometer>
    <!--If Numberline added-->
    <show-number-line
      v-if="number_line"
      :number_line="number_line"
    ></show-number-line>
    <!--If Shapes added-->
    <show-shapes
      v-if="shapes"
      :is_selectable="shapes.is_selectable"
      :shapes="shapes"
    ></show-shapes>
    <div v-if="img" style="height: 80px">
      <show-image style="max-height: 80px; height: 80px" width="80" :src="img" />
    </div>
  </div>
</template>
<script>
import ShowImage from "@/components/General/ShowImage";
import ShowCustomLayout from "@/components/Question/CustomLayout/ShowCustomLayout";
import ShowClipartLayer from "@/components/Question/ShowClipartLayer";
import ShowTables from "@/components/Question/ShowTables";
import ShowClock from "@/components/Question/Clock/ShowClock";
import ShowProtractor from "@/components/Question/Protractor/ShowProtractor";
import ShowBarChart from "@/components/Question/Charts/ShowBarChart";
import ShowLineChart from "@/components/Question/Charts/ShowLineChart";
import ShowThermometer from "@/components/Question/Thermometer/ShowThermometer";
import ShowNumberLine from "@/components/Question/NumberLine/ShowNumberLine";
import ShowShapes from "@/components/Question/Shapes/ShowShapes";
import ShowFractions from "@/components/UI/ShowFractions";
import { containsFractions } from "@/utils/fractionRenderer";
export default {
  name: "focus-button",
  props: {
    clicked_state: {
      // This tells whether to track if this button is clicked or not
      type: Boolean,
      default: true,
    },
    display_type: {
      type: String,
      default: "D",
    },
    text: {
      type: String,
      default: "",
    },
    img: {
      type: String,
      default: null,
    },
    layer: {
      type: Object,
      default: null,
    },
    layers: {
      type: Array,
      default: function () {
        return [];
      },
    },
    tables: {
      type: Array,
      default: function () {
        return [];
      },
    },
    is_clicked: {
      type: Boolean,
      default: false,
    },
    custom_width: {
      type: Number,
      default: null,
    },
    styles: {
      type: Object,
      default: null,
    },
    custom_layout: {
      type: Object,
      default: null,
    },
    clock: {
      type: Object,
      default: null,
    },
    protractor: {
      type: Object,
      default: null,
    },
    bar_chart: {
      type: Object,
      default: null,
    },
    line_chart: {
      type: Object,
      default: null,
    },
    thermometer: {
      type: Object,
      default: null,
    },
    number_line: {
      type: Object,
      default: null,
    },
    shapes: {
      type: Object,
      default: null,
    },
  },
  components: {
    ShowImage,
    ShowClipartLayer,
    ShowTables,
    ShowCustomLayout,
    ShowClock,
    ShowProtractor,
    ShowBarChart,
    ShowLineChart,
    ShowThermometer,
    ShowNumberLine,
    ShowShapes,
    ShowFractions,
  },
  data() {
    return {
      clicked: false,
    };
  },
  watch: {
    is_clicked: function (new_val) {
      this.clicked = new_val;
    },
  },
  computed: {
    buttonAStyles() {
      let styles = {};

      if (this.bar_chart) {
        // If bar chart then give full width
        styles["width"] = "100%";
      }

      if (this.custom_width) {
        styles["width"] = `${this.custom_width}px`;
      }

      if (this.display_type == "S") {
        let border_color = "#2acdc1";
        let border_width = 2;
        if (this.styles) {
          if (this.styles.border_width) {
            border_width = this.styles.border_width;
          }
          if (this.styles.border_color) {
            border_color = this.styles.border_color;
          }
        }

        styles["border"] = `${border_width}px solid ${border_color}`;
      }

      let font_size = this.display_type == "S" ? 16 : 20;
      let text_align = this.display_type == "S" ? "left" : "center";
      let font_color = this.display_type == "S" ? "#2acdc1" : "#fff";

      if (this.styles) {
        if (this.styles.font_size) {
          font_size = this.styles.font_size;
        }
        if (this.styles.text_align) {
          text_align = this.styles.text_align;
        }
        if (this.styles.font_color) {
          font_color = this.styles.font_color;
        }
        if(this.styles.background_color){
          styles["backgroundColor"] = this.styles.background_color;
        }
      }

      styles["fontSize"] = `${font_size}px`;
      styles["textAlign"] = `${text_align}`;
      styles["color"] = `${font_color}`;

      

      return styles;
    },
  },
  methods: {
    buttonClicked() {
      this.clicked = !this.clicked;
      this.$emit("clicked", this.clicked);

      if (!this.clicked_state) {
        // if we dont want to track, then again update to original
        this.clicked = !this.clicked;
      }
    },
    containsFractions,
  },
};
</script>
<style scoped>
.clicked-btn {
  background-color: #ff9500 !important;
  color: #000 !important;
}
.simple-2d {
  padding: 8px;
  float: left;
  font-weight: bold;
}
.button-3d {
  font-family: Helvetica, sans-serif;
  font-weight: bold;
  text-decoration: none;
  background-color: #4895ef;
  position: relative;
  padding: 5px 15px;
  position: relative;
  display: inline-block;

  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  text-shadow: 0px 1px 0px #000;
  filter: dropshadow(color=#000, offx=0px, offy=1px);

  -webkit-box-shadow: inset 0 1px 0 #ffe5c4, 0 10px 0 #3f37c9;
  -moz-box-shadow: inset 0 1px 0 #ffe5c4, 0 10px 0 #3f37c9;
  box-shadow: inset 0 1px 0 #ffe5c4, 0 10px 0 #3f37c9;

  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.button-3d a:active {
  top: 10px;
  background-color: #4361ee;

  -webkit-box-shadow: inset 0 1px 0 #ffe5c4, inset 0 -3px 0 #3f37c9;
  -moz-box-shadow: inset 0 1px 0 #ffe5c4, inset 0 -3pxpx 0 #3f37c9;
  box-shadow: inset 0 1px 0 #ffe5c4, inset 0 -3px 0 #3f37c9;
}

.button-3d:after {
  content: "";
  height: 100%;
  width: 100%;
  padding: 4px;
  position: absolute;
  bottom: -15px;
  left: -4px;
  z-index: -1;
  background-color: #4361ee;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

/* Fraction styles are now handled by ShowFractions component */
</style>
